

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class InsFeature extends Vue {
  featureData: object = {};
  Contents: object[] = [];
  intro: string = '';

  getFeatureData () {
    this.$Api.cms.getCategoryByDevice({ CatId: 40116, IsMobile: this.isMobile, SortName: 'CreateDate', SortOrder: 'asc' }).then((result) => {
      this.featureData = result;
      this.Contents = result.Contents;
    });
  }

  getIntro () {
    this.$Api.cms.getCategoryByDevice({ CatId: 50131, IsMobile: this.isMobile }).then((result) => {
      this.intro = result.Content;
    });
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  get lang () {
    return this.$Storage.get('locale');
  }

  mounted () {
    this.getFeatureData();
    this.getIntro();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getFeatureData();
    this.getIntro();
  }
}
